import React,{useState,useEffect} from "react";
import {Avatar, Button, IconButton, Tooltip} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DropdownMenu,{TypeItem} from "../core/DropdownMenu";

import { useDispatch,useSelector } from "react-redux";
import {logout, switchApp} from '../store/actions';
import client from "../services/client";
import auth from "../services/auth";


const menuList:TypeItem[] = [
    {title:'Profile',to:'',icon:'',avatar:true,sep:false},
    {title:'My Account',to:'',icon:'',avatar:true,sep:true},
    {title:'Settings',to:'',icon:'settings',avatar:false,sep:false},
    {title:'Logout',to:'',icon:'logout',avatar:false,sep:false}
];

const ProfileMenu:React.FC = (props:any)=>{
    
    const dispatch = useDispatch();
    
    const userName = useSelector((state:any)=>state.user.name);

    const [MenuList,setMenuList] = useState<TypeItem[]|[]>();

    const [menuEl, setMenuEl] = React.useState<null | HTMLElement>(null);
    const menuOpen = Boolean(menuEl);
    const menuClick = (event: React.MouseEvent<HTMLElement>) => {
        setMenuEl(event.currentTarget);
    };
    const menuClose = () => {
        setMenuEl(null);
    };

    const onItemClick = async (item:any)=>{
        if(item.title === 'Logout'){
            let res:any = await auth.logout();
            if(res && res.success){
                dispatch(logout());
            }
        }
    }

    useEffect(()=>{
        setMenuList(menuList);
    },[])

    const getNameFirstCharacter =()=> userName[0].toUpperCase();

    return (
        <>
            <Tooltip title="Account settings">
                <IconButton onClick={menuClick} size="small" sx={{ ml: 2 }}>
                    <Avatar sx={{ width: 25, height: 25,fontSize:'13px',background:'#11417f',color:'#fff' }} >{getNameFirstCharacter()}</Avatar>
                </IconButton>
            </Tooltip>
            <DropdownMenu 
                menuEl={menuEl} 
                menuOpen={menuOpen} 
                onClose={menuClose} 
                onClick={menuClose} 
                menuList={MenuList}
                onItemClick={onItemClick}/>
            
        </>
    );
}

export default ProfileMenu;